import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import '../base/Theme.css';
import './Withdraw.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import Input from "../base/input/Input";
import Button from "../base/button/Button";
import Loader from "../base/loader/Loader";
import Toolbar from "../base/toolbar/Toolbar";
import Text from "../base/text/Text";
import Space from "../base/space/Space";
import {withdraw} from "../../data/Api";
import ValueInput from "../base/valueinput/ValueInput";
import {Players} from "../../firebase/Collections";
import {mapToPlayer} from "../../firebase/Mappers";
import {showError, showSuccess} from "../base/toaster/CustomToaster";
import {miotaToIota} from "../../utils/Converter";
import Back from "../base/back/Back";
import {formatValue} from "../../utils/Formatter";

function Withdraw() {
    const history = useHistory();
    const [address, setAddress] = useState("");
    const [amount, setAmount] = useState("1");
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        watchPlayer();
    }, [])

    const watchPlayer = () => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (!user) {
                history.push("/login");
            } else {
                firebase.firestore()
                    .collection(Players.NAME)
                    .doc(user.uid)
                    .onSnapshot((doc) => {
                        const player = mapToPlayer(doc);
                        setPlayer(player);
                    });
            }
        });
    }

    const onAddressChanged = (address) => {
        setAddress(address);
    }

    const onAmountChanged = (value) => {
        setAmount(value);
    }

    const onWithdrawClick = async () => {
        if (player?.tableId) {
            showError("You can't withdraw tokens while seating.");
            return;
        }
        if (!address?.trim()) {
            showError("Please enter the address.");
            return;
        }
        if (!amount?.trim()) {
            showError("Please enter the amount.");
            return;
        }
        const amountToWithdraw = miotaToIota(amount);
        if (player?.money < amountToWithdraw) {
            showError("You don't have enough tokens.");
            return;
        }

        setLoading(true);
        try {
            await withdraw(address, amountToWithdraw);
            showSuccess("Success. The transaction can take up to 24 hours.");
        } catch (e) {
            showError(e.response.data);
        }
        setLoading(false);
    }

    if (!player || loading) {
        return <div className={"Root"}>
            <Loader/>
        </div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Withdraw"} leftButton={<Back/>}/>
                <Text style="WithdrawDescription"
                      text={"This is the place where you can withdraw your Iota tokens to the Firefly wallet."}/>
                <Space space={8}/>
                <Text style="WithdrawDescription"
                      text={"Enter the amount and address where you want to send your tokens. " +
                      "Then press 'Submit' button and tokens will be sent to your Firefly wallet."}/>
                <Space space={32}/>
                <Input disabled={true} type="text" text={formatValue(player?.money)}/>
                <Space space={8}/>
                <Input type="text" placeholder={"Address"} text={address} onTextChanged={onAddressChanged}/>
                <Space space={8}/>
                <ValueInput type="text" unit={"Mi"} placeholder={"Amount"} text={amount}
                            onValueChanged={onAmountChanged}/>
                <Space space={16}/>
                <Button text={"Submit"} onClick={onWithdrawClick}/>
            </div>
        </div>
    );
}

export default Withdraw;
